import { Search } from '@mui/icons-material'
import { Box, InputAdornment, TextField } from '@mui/material'
import React from 'react'

interface ITableSearchBar {
  value: string
  handleChange: (value: string) => void
  label?: string
}

const TableSearchBar: React.FC<ITableSearchBar> = ({ handleChange, value, label }) => {
  return (
    <Box sx={{ margin: 0, marginTop: '2rem', marginBottom: '1rem', maxWidth: 420 }}>
      <TextField
        label='Pesquisar'
        placeholder={label || 'Pesquisar por nome ou CNPJ'}
        type='text'
        variant='outlined'
        sx={{ margin: '1rem 0rem' }}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <Search sx={{ opacity: 0.6 }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  )
}

export default TableSearchBar
